/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AllowedRecipientFacility } from './AllowedRecipientFacility';
import {
    AllowedRecipientFacilityFromJSON,
    AllowedRecipientFacilityFromJSONTyped,
    AllowedRecipientFacilityToJSON,
} from './AllowedRecipientFacility';

/**
 * 
 * @export
 * @interface GetAllowedRecipients200Response
 */
export interface GetAllowedRecipients200Response {
    /**
     * 
     * @type {Array<AllowedRecipientFacility>}
     * @memberof GetAllowedRecipients200Response
     */
    data?: Array<AllowedRecipientFacility>;
}

/**
 * Check if a given object implements the GetAllowedRecipients200Response interface.
 */
export function instanceOfGetAllowedRecipients200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetAllowedRecipients200ResponseFromJSON(json: any): GetAllowedRecipients200Response {
    return GetAllowedRecipients200ResponseFromJSONTyped(json, false);
}

export function GetAllowedRecipients200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAllowedRecipients200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(AllowedRecipientFacilityFromJSON)),
    };
}

export function GetAllowedRecipients200ResponseToJSON(value?: GetAllowedRecipients200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(AllowedRecipientFacilityToJSON)),
    };
}

